import { pendingSelector } from 'api/selectors'
import { userSelector } from 'auth/selectors'
import ErrorMessage from '@components/ErrorMessage'

import { addCreditCard } from '../actions'
import CreditCardForm from './CreditCardForm'

const AddCreditCard = props => {
    const { errors, addCreditCard, pending, zipCode, successCallback, shouldShowInfo } = props

    return (
        <div>
            <CreditCardForm
                onSubmit={addCreditCard}
                pending={pending}
                zip={zipCode}
                successCallback={successCallback}
                shouldShowInfo={shouldShowInfo}
            />
            {errors && errors.length > 0 && (
                /* TODO: add labels for different errors */
                <ErrorMessage messages={errors.map(error => `${error.name}: ${error.code}`)} />
            )}
        </div>
    )
}

const pendingAddCreditCardSelector = createSelector(pendingSelector, pending => pending['sixcardsTokenization'])
const zipCodeSelector = createSelector(userSelector, user => user.details.address.postalCode)

const mapStateToProps = createStructuredSelector({
    zipCode: zipCodeSelector,
    pending: pendingAddCreditCardSelector,
})

export default connect(mapStateToProps, { addCreditCard })(AddCreditCard)
